import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

import { canUserModifyPromos } from '../../../../common/helpers/users';
import Input from '../../../../common/input';
import CurrencyInput from '../../../../common/currencyInput';
import Switch from '../../../../common/checkboxSwitch';
import OptionInput from '../../../../common/optionInput';
import * as commonShapes from '../../../../common/shapes';
import AssignedShops from '../../promoCodes/components/AssignedShops';
import { RoleAllowBrand } from '../../../../auth/roleAware';
import Pill from '../../../../common/Pill';


const Form = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  rewardType,
  permissions,
  shops,
  change,
  canModify,
  isBrandPromo,
  onlyShopInBrand
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={handleSubmit}>
          <fieldset disabled={!canUserModifyPromos(permissions) || submitting || !canModify}>
            <div className="u-ph">
              <div className="layout">
                <div className="layout__item" display-if={isBrandPromo && !onlyShopInBrand}>
                  <Pill type="info">{t('settings:loyalty.brand_pill')}</Pill>
                </div>
                <div className="layout__item">
                  <Switch name="enabled" label={t('settings:loyalty.enabled_label')} />
                </div>
                <div className="layout__item">
                  <span className="c-label-new">{t('settings:loyalty.type_label')}</span>
                  <div className="layout layout--small layout--auto">
                    <div className="layout__item">
                      <OptionInput
                        name="rewardType"
                        value="transaction"
                      >
                        {t('settings:loyalty.transaction_based')}
                      </OptionInput>
                    </div>
                    <div className="layout__item">
                      <OptionInput
                        name="rewardType"
                        value="value"
                      >
                        {t('settings:loyalty.value_based')}
                      </OptionInput>
                    </div>
                  </div>
                </div>
                <div
                  className="layout__item"
                  display-if={rewardType === 'transaction'}
                >
                  <span
                    className="c-label-new"
                  >
                    {t('settings:loyalty.number_transactions_goal')}
                  </span>
                  <Input
                    className="c-input"
                    name="goalCounter"
                    type="text"
                    placeholder={t('settings:loyalty.number_transactions_placeholder')}
                  />
                </div>
                <div
                  className="layout__item"
                  display-if={rewardType === 'value'}
                >
                  <span
                    className="c-label-new"
                  >
                    {t('settings:loyalty.amount_spent_goal')}
                  </span>
                  <CurrencyInput
                    className="c-input"
                    name="goalCounter"
                    type="text"
                  />
                </div>
                <div
                  className="layout__item"
                  display-if={rewardType === 'transaction'}
                >
                  <span className="c-label-new">{t('settings:loyalty.min_transaction_amount')}</span>
                  <CurrencyInput
                    className="c-input"
                    name="minTransactionAmount"
                    type="text"
                    placeholder={t('settings:loyalty.min_transaction_placeholder')}
                  />
                </div>
                <div className="layout__item">
                  <span className="c-label-new">{t('settings:loyalty.reward_amount_label')}</span>
                  <CurrencyInput
                    type="number"
                    className="c-input"
                    name="rewardAmount"
                    placeholder={t('settings:loyalty.reward_amount_placeholder')}
                  />
                </div>

                <Switch name="includeProductSales" label={t('settings:loyalty.include_product_sales')} wrapperClass="layout__item" />
                <Switch name="includeTips" label={t('settings:loyalty.include_tips')} wrapperClass="layout__item" />

                <RoleAllowBrand>
                  <div className="layout__item">
                    <span className="c-label-new">{t('settings:loyalty.assigned_shops_label')}</span>
                    <AssignedShops shops={shops} change={change} />
                  </div>
                </RoleAllowBrand>
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right" display-if={canModify}>
              <button
                type="submit"
                className="c-btn u-width-120"
                disabled={pristine || !valid}
              >
                <span className="c-btn__text">{t('settings:loyalty.save_button')}</span>
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
);

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  valid: PropTypes.bool,
  rewardType: PropTypes.string,
  permissions: commonShapes.permissions.isRequired,
  shops: PropTypes.array,
  change: PropTypes.func.isRequired,
  canModify: PropTypes.bool,
  isBrandPromo: PropTypes.bool,
  onlyShopInBrand: PropTypes.bool.isRequired,
};
Form.defaultProps = {
  handleSubmit: () => null,
  pristine: false,
  submitting: false,
  valid: false,
  canModify: false,
  isBrandPromo: false,
  rewardType: '',
  shops: [],
};

export default Form;
